import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Menu, message } from 'antd';
import moment from 'moment';

const DopdownMenuWithMonth = ({ lastGeneratedMonths = [], name, onSelectMonth, loading, isLoadingGenerate, setIsLoadingGenerate }) => {
  const [visible, setVisible] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const currentMonth = moment().format('MMMM');
  const allMonths = moment.months();

  // Reorder months: April to March
  const months = [...allMonths.slice(3), ...allMonths.slice(0, 3)];

  // const lastGeneratedMonthsfilter = 
  //   lastGeneratedMonths.filter(month => months.includes(month));

  const financialMonths1 = [
    'April', 'May', 'June', 'July', 'August', 'September',
    'October', 'November', 'December', 'January', 'February', 'March'
  ];

  let jsMonth = new Date().getMonth();

  jsMonth = jsMonth - 1;
  if (jsMonth < 0) {
    jsMonth = 11;
  }


  let financialMonthIndex;
  if (jsMonth >= 3) {
    financialMonthIndex = jsMonth - 3;
  } else {
    financialMonthIndex = jsMonth + 9;
  }

  const currentMonthName = financialMonths1[financialMonthIndex];




  // Filter out months above the current month
  const lastGeneratedMonthsfilter = lastGeneratedMonths.filter(month => {
    const monthIndex = financialMonths1.indexOf(month);
    const currentMonthIndex = financialMonths1.indexOf(currentMonthName);
    return monthIndex <= currentMonthIndex;
  });





  const handleClick = (month) => {
    setIsLoadingGenerate(true);
    // setIsLoadingReGenerate(true);
    // setLoading(true);

    // Perform your async action (e.g., fetch data, API call)
    // For this example, we'll simulate a delay
    setTimeout(() => {
      // After the action is complete, set loading back to false
      // setIsLoading(false);
      // You can also hide the dropdown if you want
      setVisible(false);
      // message.success(`Payout generated for month: ${month}`);
    }, 2000);

    if (onSelectMonth) {
      onSelectMonth(month);
    }

    // setVisible(false);
    // setIsLoading(false)
  };

  const menu = (
    <Menu style={{ maxHeight: 500, overflow: 'auto' }}>
      {months.map((month) => (
        <Menu.Item
          key={month}
          disabled={!lastGeneratedMonthsfilter.includes(month)}
          onClick={() => handleClick(month)}
        >
          {month}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      open={visible}
      onOpenChange={(flag) => setVisible(flag)}
      disabled={loading}
    >
      <Button
        className="ant-btn ant-btn-default"
        type="primary"
        style={{
          width: 150,
          margin: 5,
          fontSize: '0.8rem',
          justifyContent: 'center',
          overflow: 'hidden',
          padding: 10,
          backgroundColor: "#1b8593",
          color: "white",
          borderRadius: "5px",
          border: 'none',
        }}
        loading={isLoadingGenerate}
      >
        {visible ? 'Select Month' : name}
      </Button>
    </Dropdown>
  );
};

DopdownMenuWithMonth.propTypes = {
  lastGeneratedMonths: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
};


DopdownMenuWithMonth.defaultProps = {
  lastGeneratedMonths: [],
  name: 'Dropdown Menu',
};

export default DopdownMenuWithMonth;